import tableStyles from "@/_styles/table.module.scss"

import { IFinanceReturnFunds } from "@/types/IFinanceReturnFunds"
import { ITableColumn } from "@/types/ui"

import { dateTimeFormat, formatDate } from "@/utils/formatDate"
import { getMoney } from "@/utils/formatNumber"

export const FinanceReturnFundsColumns: ITableColumn<IFinanceReturnFunds>[] = [
  {
    title: "Номер записи",
    key: "id",
    dataIndex: ["id"],
    render: (_, { id }) => <span className={tableStyles["text-gray"]}>{ id }</span>,
    sorter: true,
    width: 100,
    isVisible: false,
    order: 1
  },
  {
    title: "Дата",
    key: "date",
    dataIndex: ["date"],
    sorter: true,
    defaultSortOrder: "descend",
    width: 100,
    isVisible: true,
    order: 2,
    render: (_, { date }) => <span className={tableStyles["text-gray"]}>{ date && <>{formatDate(date)}</> }</span>
  },
  {
    title: "Статус",
    key: "status",
    dataIndex: ["statusText"],
    render: (_, { statusText }) => <span className={tableStyles["text-bold"]}>{statusText}</span>,
    sorter: true,
    width: 100,
    isVisible: true,
    order: 3
  },
  {
    title: "Контрагент",
    key: "customerId",
    dataIndex: ["customerId"],
    render: (_, { customer }) => <span className={tableStyles["text-gray"]}>{customer?.name}</span>,
    sorter: true,
    width: 100,
    isVisible: true,
    order: 4
  },
  {
    title: "Сумма",
    key: "sum",
    dataIndex: ["sum"],
    render: (_, { sum }) => <span className={tableStyles["text-summ"]}>{getMoney(sum)}</span>,
    sorter: true,
    width: 100,
    isVisible: true,
    order: 5
  },
  {
    title: "Дата создания",
    key: "createdOn",
    dataIndex: ["createdOn"],
    render: (_, { createdOn }) => <span className={tableStyles["text-gray"]}>{formatDate(createdOn, dateTimeFormat)}</span>,
    sorter: true,
    width: 200,
    isVisible: true,
    order: 6
  }
]
